import './ListItem.scss';

import React from 'react';
import MuiListItem from '@material-ui/core/ListItem';
import { omit } from 'lodash';

import { cxFunction } from 'util/className';

const ListItem = ({ theme, cx, ...props }) => (
  <MuiListItem
    classes={{
      root: cx({ [`theme-${theme}`]: !!theme }),
    }}
    {...omit(props, 'cxEl')}
  />
);

export default cxFunction('ListItem', ListItem);
